<template>
  <div class="">
    <v-card
      v-for="item in dotdangkies"
      :key="item.dotDangKyId"
      :title="true"
      :elevation="7"
      class="pt-5 pb-5 pl-1 pr-1 mt-3 mb-3"
    >
      <div class="row">
        <div class="col-md-9 col-8">
          <div class="row">
            <div
              class="col-md-5 col-12 d-flex align-items-center text-uppercase font-weight-bold"
            >
              <div class="text-md-center w-100">{{ item.tenDot }}</div>
            </div>
            <div class="col-md-2 col-12">
              {{ $t("date.ngayDangKy") }}: {{ item.ngayBatDau | formatDate }}
            </div>
            <div class="col-md-2 col-12">
              {{ $t("date.endDay") }}: {{ item.ngayKetThuc | formatDate }}
            </div>
            <div class="col-md-2 col-12">
              {{ $t("date.ngayCongBo") }}: {{ item.ngayCongBo | formatDate }}
            </div>
          </div>
        </div>
        <div class="col-md-2 col-4 d-flex align-items-center">
          <div class="row">
            <div
              :class="{ 'text-danger': item.loaiDot === 'HOCBA' }"
              class="col-md-12 col-12"
            >
              <button
                :class="[addClassButton(item), 'btn form-control']"
                @click="clickButton(item)"
                :disabled="checkDisabled(item)"
              >
                {{ textButton(item) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <div class="row">
      <div class="col"></div>
    </div>

    <modal
      name="dangky-thaydoi"
      :min-width="150"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="70%"
      height="auto"
      @closed="soCmnd = ''"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(timKiem)">
          <div class="container">
            <div class="row">
              <div class="col-12 offset-md-2 col-md-8">
                <label for="txtSoCmnd">
                  {{ $t("message.title.nhapSoCmnd") }}:
                </label>
                <validation-provider
                  :name="$t('models.thiSinh.cmnd')"
                  :rules="`required`"
                  v-slot="{ errors, valid }"
                >
                  <input
                    id="txtNhapCMND"
                    type="text"
                    class="form-control"
                    v-model="soCmnd"
                    :placeholder="$t('message.title.nhapSoCmnd')"
                    :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                  />

                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 offset-md-2 col-6">
                <button class="btn btn-info form-control" id="btnXacNhan">
                  {{ $t("button.xacNhan") }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </modal>
  </div>
</template>

<script>
import HomePage from "../js/homepage";
export default HomePage;
</script>

<style scoped>
.inactive {
  cursor: not-allowed;
}
button {
  height: 100%;
}
.vm--modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: auto !important;
}
</style>
